import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/promo/actions/appAction';
import { CommonPagePromo } from 'apps/promo/components/common/CommonPagePromo';
import { LightHeaderPanel } from 'apps/promo/components/common/fromAuth/LightHeaderPanel/LightHeaderPanel';
import { LightIcon } from 'apps/promo/components/common/fromAuth/LightIcon/LightIcon';
import { LightText } from 'apps/promo/components/common/fromAuth/LightText/LightText';
import IconSvg from 'apps/promo/components/common/widgets/Illustration/IconSvg';
import ZendeskHelpMobileSearch from 'apps/promo/components/help/ZendeskHelpMobileSearch';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'apps/promo/components/utils';
import { USER_THEME_DARK } from 'apps/promo/constants/Constants';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';

import styles from './ZendeskHelpMobile.module.css';

const ZendeskHelpMobilePage = (props) => {
    const url = `${getLangCountryPrefix(props.lang, props.country)}/help-mobile`;
    const urlParams = useGetQueryParams();

    const filteredCategories = props.categories?.filter((category) => {
        return !category.directLink;
    });

    const isDarkTheme = urlParams.mode === USER_THEME_DARK;

    const getCategoryIcon = (category) => {
        const findIcon = (icons) => icons?.find((i) => Number(i.category_id) === category.id);
        const icon = (isDarkTheme && findIcon(props.categoryIconsDark)) || findIcon(props.categoryIcons);
        return (
            <span className={`${icon ? styles.iconContainer : ''}`}>
                <IconSvg img={icon?.category_icon} width={'24'} height={'24'} />
            </span>
        );
    };

    const categories = filteredCategories?.map((item) => {
        return (
            <a className={styles.mobileHelpLink} key={item.id} href={getHelpCenterUrl(`${url}/category/${item.id}`, urlParams)}>
                <span>
                    {(props.categoryIcons || props.categoryIconsDark) && getCategoryIcon(item)}
                    <LightText>{item.name}</LightText>
                </span>
                <LightIcon name="chevron-right" color="primary" leftIndent={'16px'} />
            </a>
        );
    });

    const popularArticles = props.popular?.map((article) => {
        const section = props.sections?.find((s) => s.id === article.section_id);
        return (
            <a
                className={styles.mobileHelpLink}
                key={article.id}
                href={getHelpCenterUrl(`${url}/category/${section.category_id}/section/${article.section_id}/article/${article.id}`, urlParams)}
            >
                <LightText>{article.title}</LightText>
                <LightIcon name="chevron-right" color="primary" leftIndent={'16px'} />
            </a>
        );
    });

    const promotedArticles = props.promoted?.map((article) => {
        const section = props.sections?.find((s) => s.id === article.section_id);
        return (
            <a
                className={styles.mobileHelpLink}
                key={article.id}
                href={getHelpCenterUrl(`${url}/category/${section.category_id}/section/${article.section_id}/article/${article.id}`, urlParams)}
            >
                <LightText>{article.title}</LightText>
                <LightIcon name="chevron-right" color="primary" leftIndent={'16px'} />
            </a>
        );
    });

    return (
        <CommonPagePromo
            backUrl={!urlParams.platform ? props.backUrl : null}
            type={'tagA'}
            leftCloseIcon
            useThemeColor
            onClickIcon={() => {
                props.toggleSpinner(true);
                sessionStorage?.removeItem('prevUrl');
            }}
        >
            <LightHeaderPanel useThemeColor title={props.pageHeadline} />
            <ZendeskHelpMobileSearch
                isMobilePlatform={urlParams.platform === 'ios' || urlParams.platform === 'android'}
                hasFixedIndent={urlParams.version === 'c3p0'}
            />
            {props.popular && props.popular.length > 0 && (
                <>
                    <div className={styles.subheaderContainer}>
                        <LightText color="secondary" size="subheader">
                            {props.popularArticlesTitle}
                        </LightText>
                    </div>
                    {popularArticles}
                    <div className={styles.separator}></div>
                </>
            )}
            {props.promoted && props.promoted.length > 0 && (
                <>
                    <div className={styles.subheaderContainer}>
                        <LightText color="secondary" size="subheader">
                            {props.promotedArticlesTitle}
                        </LightText>
                    </div>
                    {promotedArticles}
                    <div className={styles.separator}></div>
                </>
            )}
            {categories}
        </CommonPagePromo>
    );
};

const mapStateToProps = ({ extra }) => ({
    pageHeadline: extra?.strapiApi?.page_headline_mobile?.title,
    promotedArticlesTitle: extra?.strapiApi?.promoted_articles_title,
    categoryIcons: extra?.strapiApi?.zendesk_categories_icons,
    categoryIconsDark: extra?.strapiApi?.zendesk_categories_icons_dark,
    categories: extra?.zendeskHelpData?.categories,
    sections: extra?.zendeskHelpData?.sections,
    promoted: extra?.zendeskHelpData?.promoted,
    popular: extra?.zendeskHelpData?.popular,
    popularArticlesTitle: extra?.strapiApi?.popular_articles_title,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleSpinner })(NotAuthBasePage(ZendeskHelpMobilePage));
